import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [company, setCompany] = useState(null);

  const load = useCallback(async () => {
    const token = localStorage.getItem("etkinlik_token");
    if (!token) {
      setUser(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company || null);
    } catch {
      localStorage.removeItem("etkinlik_token");
      setUser(null);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const applySession = (token, u, c = null) => {
    localStorage.setItem("etkinlik_token", token);
    setUser(u);
    setCompany(c);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) return data;
    applySession(data.token, data.user);
    const me = await api.get("/auth/me");
    setCompany(me.data.company || null);
    return data.user;
  };

  const verify2fa = async (email, code) => {
    const { data } = await api.post("/auth/verify-2fa", { email, code });
    applySession(data.token, data.user);
    const me = await api.get("/auth/me");
    setCompany(me.data.company || null);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    applySession(data.token, data.user);
    const me = await api.get("/auth/me");
    setCompany(me.data.company || null);
    return data.user;
  };

  const impersonate = (token, u, c) => applySession(token, u, c);

  const logout = () => {
    localStorage.removeItem("etkinlik_token");
    setUser(null);
    setCompany(null);
  };

  const panelPath = (u = user) => {
    if (!u) return "/giris";
    if (u.role === "ADMIN" || u.role === "SUPER_ADMIN") return "/admin";
    if (u.role === "COMPANY") return "/firma-panel";
    return "/panel";
  };

  return (
    <AuthContext.Provider value={{ user, company, setCompany, login, register, logout, impersonate, verify2fa, panelPath, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
